<template>
	<div>
		<div v-if="loading" style="height: 90vh; overflow-y: auto">
			<loading-generic :is-loading="loading"></loading-generic>
		</div>
		<div style="height: 90vh; overflow-y: auto" :key="idroute">
			<flowchart-modals v-if="question || add || showModalWiki"></flowchart-modals>
			<builder-element v-if="showModalEdit !== undefined"></builder-element>

			<div style="display: flex; width: 100%">
				<div style="width: 100%; word-break: break-all">
					<div v-if="!editTitle" style="display: inline-flex; align-items: center; width: 100%">
						<div style="font-size: 36px; padding: 15px; display: flex; align-items: center; width: 100%">
							<h1 style="padding: 0; margin: 0; font-size: 36px; max-width: 50%">{{ title }}</h1>

							<el-button
								@click="editTitle = true"
								plain
								style="margin-left: 15px"
								icon="el-icon-edit"
							></el-button>
							<el-button
								@click="showModalStatus = true"
								plain
								style="margin-right: 15px"
								icon="el-icon-edit"
								>{{ $t("versions") }}
							</el-button>

							<el-slider
								v-if="variantNumber > 1"
								style="min-width: 40%"
								@change="changeVersion"
								v-model="variantValue"
								:step="1"
								:max="Number(variantArray[variantArray.length - 1].Version)"
								:min="Number(variantArray[0].Version)"
								:format-tooltip="formatTooltip"
								:marks="variantObject"
								show-stops
							/>
						</div>
					</div>
					<div v-if="!editTitle">
						<el-tag v-if="status" style="margin-left: 3px; margin-bottom: 3px" type="warning">
							{{ $t(status) }}
						</el-tag>
						<el-tag
							v-for="area in areas_tag"
							:key="area"
							style="margin-left: 3px; margin-bottom: 3px"
							type="success"
						>
							{{ area }}
						</el-tag>
						<el-tag v-for="tag in tags_tag" :key="tag" style="margin-left: 3px; margin-bottom: 3px">
							{{ tag }}
						</el-tag>
					</div>
					<div
						v-if="editTitle"
						style="font-size: 36px; padding: 15px; display: flex; align-items: center; width: auto"
					>
						<!-- name -->
						<el-input v-model="newTitle" style="width: 40%" :placeholder="title"></el-input>

						<!-- areas -->
						<el-select
							v-model="selected_areas"
							multiple
							filterable
							style="margin-left: 15px; width: 25%"
							:placeholder="$t('choose-area')"
						>
							<el-option
								v-for="item in areas"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							/>
						</el-select>

						<!-- tags -->
						<el-select
							v-model="selected_tags"
							multiple
							filterable
							style="margin-left: 15px; width: 25%"
							:placeholder="$t('tags')"
						>
							<el-option v-for="item in tags" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>

						<el-button
							@click="
								newTitle ? (title = newTitle) : null
								editTitle = false
							"
							plain
							style="margin-left: 15px"
							icon="el-icon-check"
						/>
						<el-button @click="editTitle = false" plain style="margin-left: 15px" icon="el-icon-close" />
					</div>
				</div>
			</div>
			<div>
				<el-card class="option" style="z-index: auto; position: relative">
					<div style="display: inline-flex; width: 100%">
						<el-button style="z-index: auto; margin: 0 30px 0 0" @click="exitEdit" icon="el-icon-back"
							>{{ $t("back") }}
						</el-button>

						<div style="margin-right: 0; margin-left: auto; width: max-content">
							<!--						ALLEGATI  -->
							<!--						NON MI METTO A fare cose -->

							<el-dialog :title="$t('attachments')" :visible.sync="dialogAllegati" width="30%">
								<div v-if="selected_nodes[0]">
									<el-card
										v-for="(file, index) in selected_nodes[0].zip_attachments"
										class="box-card"
										shadow="hover"
										:key="index"
										style="margin-bottom: 2px"
									>
										<div class="text item">
											{{ file }}
											<el-button
												@click="selected_nodes[0].zip_attachments.splice(index, 1)"
												style="float: right; padding: 3px 0"
												type="text"
												>{{ $t("delete") }}</el-button
											>
										</div>
									</el-card>
								</div>
								<span
									v-if="
										selected_nodes[0] &&
										selected_nodes[0].zip_attachments &&
										selected_nodes[0].zip_attachments.length == 0
									"
									>{{ $t("no-files") }}</span
								>

								<md-field>
									<label>{{ $t("upload-file") }}</label>
									<md-file @md-change="loadFile" v-if="selected_nodes[0]" />
								</md-field>

								<span slot="footer">
									<el-button type="primary" @click="dialogAllegati = false">{{
										$t("close")
									}}</el-button>
								</span>
							</el-dialog>

							<el-button
								style="z-index: 0; margin: 0 15px; display: none; width: 0; height: 0"
								@click="dialogAllegati = true"
								icon="el-icon-plus"
								type="success"
								plain
							>
								{{ $t("attachments") }}
							</el-button>

							<!--						FINE ALLEGATI -->

							<el-button
								style="z-index: auto; margin: 0 15px"
								@click="newNode($store)"
								icon="el-icon-plus"
								type="success"
								plain
							>
								{{ $t("new-node") }}
							</el-button>

							<el-popover v-if="idroute" placement="top" width="350" v-model="visible">
								<p style="word-break: keep-all">
									<strong>{{ $t("update-current-version") }}: </strong>
									{{ $t("update-current-version-explaination") }}
								</p>
								<p style="word-break: keep-all">
									<strong>{{ $t("save-new-version") }}: </strong>
									{{ $t("save-new-version-explaination") }}
								</p>
								<p style="word-break: keep-all">
									<strong>{{ $t("save-new") }}: </strong>
									{{ $t("save-new-explaination") }}
								</p>

								<div style="text-align: right; margin: 0; display: flex; flex-direction: column">
									<el-button
										style="margin: 3px"
										type="primary"
										@click="
											visible = false
											verifyBalls() ? UpdateActual() : undefined
										"
									>
										{{ $t("update-current-version") }}
									</el-button>
									<el-button
										style="margin: 3px"
										type="primary"
										@click="
											visible = false
											verifyBalls() ? saveUpdate() : undefined
										"
									>
										{{ $t("save-new-version") }}
									</el-button>
									<el-button
										style="margin: 3px"
										type="primary"
										@click="
											visible = false
											verifyBalls() ? saveFlw(true) : undefined
										"
									>
										{{ $t("save-new") }}
									</el-button>
								</div>
								<el-button slot="reference" type="primary" style="z-index: auto; margin: 0 15px" plain
									>{{ $t("save-or-update") }}
								</el-button>
							</el-popover>

							<el-button
								v-else
								style="z-index: auto; margin: 0 15px"
								plain
								type="primary"
								@click="verifyBalls() ? saveFlw(false) : undefined"
								>{{ $t("save") }}
							</el-button>

							<el-button
								style="z-index: auto; margin: 0 15px"
								icon="el-icon-view"
								@click="verifyBalls() ? (showModal = true) : (showModal = false)"
								>{{ $t("preview") }}
							</el-button>
						</div>
					</div>
				</el-card>
			</div>
			<div style="display: inline-flex; width: 100%">
				<div style="display: inline-flex; height: 70vh; width: 33%">
					<!-- flowchart -->
					<div id="drawflow" />
				</div>

				<div
					style="display: inline-flex; flex-direction: column; height: 70vh; width: 66%"
					v-if="showModalEdit !== undefined"
				>
					<visual-builder :key="selected_node"></visual-builder>
				</div>
			</div>
			<div v-if="node" style="z-index: 99999999999999">
				<md-dialog :md-active="node != undefined">
					<div style="padding: 20px">
						<input v-model="node.input" type="number" placeholder="INPUT" />
						<br />
						<input v-model="node.output" type="number" placeholder="OUTPUT" />
						<br />
					</div>
					<el-button @click="node = undefined">{{ $t("cancel") }}</el-button>
					<el-button @click="handleActionNode">OK</el-button>
				</md-dialog>
			</div>
			<!--        render modal-->
			<!-- <el-dialog
			:title="$t('preview')"
			:visible.sync="showModal"
			width="80%"
		>
			<flat-renderer v-if="showModal" :dati="selected_nodes" id="rend"></flat-renderer>

			<el-button type="primary" @click="showModal = false">{{$t("close")}}</el-button>
		</el-dialog> -->

			<el-dialog :title="$t('preview')" :visible.sync="showModal" width="80%">
				<span slot="title"><i class="el-icon-document" style="margin-right: 10px"></i>{{ $t("preview") }}</span>
				<flat-renderer
					:logged="true"
					v-if="showModal"
					:dati="selected_nodes"
					id="rend"
					:toggleBorders="toggleBorders"
				/>
				<span slot="footer">
					<el-switch
						v-model="toggleBorders"
						:active-text="$t('with-borders')"
						:inactive-text="$t('without-borders')"
					/>
					<el-button style="margin-left: 20px" type="primary" @click="showModal = false">{{
						$t("close")
					}}</el-button>
				</span>
			</el-dialog>

			<versions-modal
				:show="showModalStatus"
				@close="showModalStatus = false"
				:statusesPerVersions="statusesPerVersions"
				@refresh="initPage"
			/>
		</div>
	</div>
</template>

<script>
import FlowchartBlock from "./components/flowchart-block"
import VisualBuilder from "@/modules/builder/Builder"
import BuilderElement from "@/modules/builder/builder-element"
import VersionsModal from "@/modules/documents/components/versions-modal"
import { mapActions, mapGetters, mapMutations } from "vuex"
import FlatRenderer from "@/modules/flowcharts/flat-renderer"
import FlowchartModals from "@/modules/flowcharts/components/flowchart-modals"
import axios from "axios"
import { i18n } from "@/plugins/i18n"
import { goto } from "@/utils/utils"
import moment from "moment"
import VueResizable from "vue-resizable"
import LoadingGeneric from "@/modules/_common/loading-generic"

export default {
	name: "flowchart-layout",
	props: {
		flow: {
			required: false,
			type: Object
		},
		idroute: {
			required: false,
			type: String
		}
	},
	components: {
		FlowchartModals,
		FlatRenderer,
		VisualBuilder,
		"flowchart-block": FlowchartBlock,
		BuilderElement,
		VersionsModal,
		VueResizable,
		LoadingGeneric
	},
	computed: {
		...mapGetters({
			selected_nodes: "flowchart/nodes",
			showModalEdit: "flowchart/showModalEdit",
			question: "flowchart/showModalQuestion",
			showModalWiki: "flowchart/showModalWiki",
			selected_node: "flowchart/showModalEdit",
			add: "flowchart/showModalInsert",
			editor: "flowchart/editor"
		}),
		variantObject() {
			let variantObject = {}
			this.variantArray.forEach(x => {
				if (x.Status != "published") variantObject[x.Version] = x.Version
				else
					variantObject[x.Version] = {
						style: { color: "#1989FA" },
						label: this.$createElement("strong", x.Version)
					}
			})
			return variantObject
		},
		areas_tag() {
			if (Array.isArray(this.selected_areas))
				return this.areas.filter(el => this.selected_areas.includes(el.value)).map(el => el.label)
			return []
		},
		tags_tag() {
			if (Array.isArray(this.selected_tags))
				return this.tags.filter(el => this.selected_tags.includes(el.value)).map(el => el.label)
			return []
		}
	},
	data() {
		return {
			node: undefined,
			showModal: false,
			id: 0,
			watched: 0,
			zoom: { current: 50, precedent: 50 },
			styleObj: {
				height: window.innerHeight - 200
			},
			trees: {},
			explored: [],
			document: [],
			tests: [],
			selectedFlowchart: undefined,
			flowsciarts: [],
			title: this.$t("new-document"),
			status: "",
			newTitle: "",
			editTitle: false,
			visible: false,
			selected_version: undefined,
			variantValue: undefined,
			variantNumber: 0,
			variantArray: [],
			areas: [],
			tags: [],
			selected_areas: [],
			selected_tags: [],
			showModalStatus: false,
			statusesPerVersions: [],
			toggleBorders: false,
			dialogAllegati: false,
			loading: false
		}
	},
	beforeDestroy() {
		this.kill()
	},
	async mounted() {
		this.openLoad()
		await this.initPage()
		this.closeLoad()
	},
	created() {
		axios
			.get(process.env.VUE_APP_API_URL + "/api/areas/", {
				headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
			})
			.then(res => {
				res.data.areas.forEach(el => {
					this.areas.push({ value: el.id, label: el.name })
				})
			})
			.catch(err => console.error(err))

		axios
			.get(process.env.VUE_APP_API_URL + "/api/tags/", {
				headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
			})
			.then(res => {
				res.data.tags.forEach(el => {
					this.tags.push({ value: el.id, label: el.name })
				})
			})
			.catch(err => console.error(err))
	},
	methods: {
		async initPage() {
			if (this.idroute) {
				this.variantArray = []
				this.variantNumber = 0
				this.selectedFlowchart = this.idroute
				await this.loadFlw()
				await axios
					.get(process.env.VUE_APP_API_URL + "/api/flowchart/getVersions/" + this.selectedFlowchart, {
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					})
					.then(res => {
						res.data.items.forEach(el => {
							this.variantArray.push(el)
							this.variantNumber++
						})
						this.variantValue = Number(this.variantArray.find(el => el.Id == this.idroute).Version)

						this.closeLoad()
						return true
					})
					.catch(err => {
						this.$notification("warning", this.$t("warning"), this.$t("generic-error-msg"))
						if (this.idroute) {
							this.$parent.idx = undefined
							this.$parent.docs = []
							this.kill()
							this.closeLoad()
						} else {
							this.goto("/documents/")
						}
					})
			} else {
				await this.initEditor(this.$store)
			}
			return true
		},
		...mapMutations({
			openLoad: "modules/OPEN_LOADING",
			closeLoad: "modules/CLOSE_LOADING"
		}),
		goto,
		changeVersion(e) {
			if (this.variantArray.find(x => x.Version == e).Id != this.idroute) {
				this.$emit("changeVersion", this.variantArray.find(x => x.Version == e).Id)
			}
		},
		formatTooltip(val) {
			if (this.variantArray[val]) {
				return (
					moment(this.variantArray[val].updated_at.substring(0, 19) + "+02:00").format("lll") +
					" - " +
					moment(this.variantArray[val].updated_at.substring(0, 19) + "+02:00").fromNow()
				)
			} else {
				return this.$t("loading")
			}
		},
		saveFlw(copy) {
			this.loading = true
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/flowchart/saveNew",
					{
						dati: this.selected_nodes,
						nome: this.title + (copy ? " " + this.$t("copy-doc") : ""),
						areas: this.selected_areas,
						tags: this.selected_tags,
						folder: this.$route.params.folder_id
					},
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					if (res.data.status == "ok") {
						this.$notification("success", i18n.t("saved-element-generic"), "", 4500)
						if (!this.idroute) {
							this.goto("/documents/")
						} else {
							this.$parent.idx = undefined
							this.$parent.docs = []
							this.kill()
							this.closeLoad()
							this.goto("/documents/")
						}
					}
					this.loading = false
				})
				.catch(err => {
					this.$processError(this.$t("save-error"), err.response.data.Message)
					this.loading = false
				})
		},

		saveUpdate() {
			this.loading = true
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/flowchart/saveUpdate",
					{
						dati: this.selected_nodes,
						id: this.idroute,
						nome: this.title,
						areas: this.selected_areas,
						tags: this.selected_tags
					},
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					if (res.data.status == "ok") {
						this.$notification("success", i18n.t("saved-element-generic"), "", 4500)
						this.$emit("changeVersion", res.data.id)
						this.initPage()
					}
					this.loading = false
				})
				.catch(err => {
					this.$notification("warning", this.$t("warning"), this.$t("save-err"))
					this.loading = false
				})
		},
		UpdateActual() {
			this.loading = true
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/flowchart/update",
					{
						dati: this.selected_nodes,
						id: this.idroute,
						nome: this.title,
						areas: this.selected_areas,
						tags: this.selected_tags
					},
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					this.loading = false
					if (res.data.status == "ok") {
						this.$notification("success", i18n.t("saved-element-generic"), "", 4500)
						this.initPage()
					}
				})
				.catch(err => {
					this.$notification("warning", this.$t("warning"), this.$t("save-err"))
					this.loading = false
				})
		},

		async loadFlw() {
			await axios
				.get(process.env.VUE_APP_API_URL + "/api/flowchart/getSaved/" + this.selectedFlowchart, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					this.title = res.data.items.nome
					this.status = res.data.items.status
					this.newTitle = res.data.items.nome
					this.selected_areas = res.data.items.areas
					this.selected_tags = res.data.items.tags

					this.statusesPerVersions = res.data.items.versions

					this.resetNodes()
					this.cleanAndResetEditor({ store: this.$store, nodi: res.data.items.dati })
				})
				.catch(e => {
					console.error(e)
					this.$notification("warning", this.$t("warning"), this.$t("doc-not-found"))
					if (this.idroute) {
						this.$parent.idx = undefined
						this.$parent.docs = []
						this.kill()
						this.closeLoad()
					} else {
						this.goto("/documents/")
					}
				})
		},
		...mapActions({
			initEditor: "flowchart/initEditor",
			newNode: "flowchart/newNode",
			editModalEdit: "flowchart/editModalEdit",
			pushNode: "flowchart/pushNode",
			delNode: "flowchart/delNode",
			editNodeDependecies: "flowchart/editNodeDependecies",
			verifyBalls: "flowchart/verifyBalls",
			cleanAndResetEditor: "flowchart/cleanAndResetEditor"
		}),
		...mapMutations({
			pushNNNNNODE: "flowchart/PUSH_NODE",
			resetNodes: "flowchart/RESET_NODES",
			kill: "flowchart/KILL_EVERYTHING"
		}),
		showConnections() {
			// debug only
			// this.selected_nodes.forEach( el => {
			// 	console.log( "parent del nodo id: " + el.id )
			// 	console.log( el.parent )
			// 	console.log( "children del nodo id: " + el.id )
			// 	console.log( el.children )
			// 	console.log( "question del nodo id: " + el.id )
			// 	console.log( el.question )
			// 	console.log( "question map del nodo id: " + el.id )
			// 	console.log( JSON.stringify( el.question.map ) )
			// 	console.log( "answer del nodo id: " + el.id )
			// 	console.log( el.answer )
			// } )
		},
		closeEdit(event) {
			this.editModalEdit({ val: false, id: undefined })
			event.stopPropagation()
			event.preventDefault()
		},
		handleActionNode: function () {
			this.addNode(this.node)
		},
		zooming: function (e) {
			var diff = this.zoom.current - this.zoom.precedent
			this.editor.zoom_value = Math.abs(diff) / 100
			if (diff > 0) {
				this.editor.zoom_in()
			} else {
				this.editor.zoom_out()
			}
			this.zoom.precedent = e
		},
		addNodeOutput() {
			this.selected_nodes.forEach((el, index) => {
				this.editor.addNodeOutput(index)
			})
		},
		exitEdit() {
			this.$confirm(this.$t("sure-back"), this.$t("warning"), {
				confirmButtonText: "OK",
				cancelButtonText: this.$t("cancel"),
				type: "warning"
			})
				.then(() => {
					if (this.idroute) {
						this.$parent.idx = undefined
						this.kill()
					} else if (this.$route.params.folder_id) {
						this.goto("/documents/folders/" + this.$route.params.folder_id)
					} else {
						this.goto("/documents/")
					}
				})
				.catch(() => {})
		},
		loadFile: function (el) {
			// var imagefile = document.querySelector('.el-upload__input');
			var thas = this

			var formData = new FormData()
			formData.append("file", el[0])
			if (this.selected_nodes[0].zip_attachments == undefined) {
				this.selected_nodes[0].zip_attachments = []
			}
			axios
				.post(process.env.VUE_APP_API_URL + "/drive/upload", formData, {
					headers: {
						"Content-Type": "multipart/form-data",
						Authorization: "Bearer " + localStorage.getItem("JWT")
					}
				})
				.then(res => {
					this.selected_nodes[0].zip_attachments.push(res.data)
				})
				.catch(err => {
					this.$notification("warning", this.$t("warning"), this.$t("save-err"))
				})

			// document.querySelector('.el-upload__input').fileList=[]
		},
		handleRemoveFile() {}
	}
}
</script>
<style lang="scss">
@import "src/assets/scss/drawflow";

#drawflow {
	width: 100%;
	height: auto;
	border: 1px solid gray;
}

.option {
	cursor: pointer;
	z-index: auto !important;
}

input {
	padding: 7px;
}

.el-slider__button {
	margin-top: -13px;
}
</style>
